// src/pages/admin/AdminProyecto/modeloFinanciero.js
//
// Modelo financiero del documento estratégico de HolaVeci.
// Réplica exacta de la función calcularProyeccion() del HTML v5.0.
// Datos estáticos, todos los valores en COP.

const SUSCRIPCION_NETA_COP = 25210;   // $30.000 con IVA descontado
const TARIFA_NETA_COP      = 168;     // $200 con IVA descontado

function nuevosTenderosDelMes(m) {
  if (m === 1) return 8;
  if (m === 2) return 10;
  if (m === 3) return 12;
  if (m === 4) return 15;
  if (m === 5) return 18;
  if (m === 6) return 22;
  if (m === 7) return 25;
  if (m === 8) return 28;
  if (m <= 12) return 32;
  if (m <= 18) return 40;
  return 45;
}

function tasaChurn(m) {
  if (m > 18) return 0.035;
  if (m > 12) return 0.04;
  if (m > 6)  return 0.045;
  return 0.05;
}

function pedidosPorTendero(m) {
  if (m <= 2)  return 30;
  if (m <= 4)  return 40;
  if (m <= 6)  return 50;
  if (m <= 9)  return 65;
  if (m <= 12) return 80;
  if (m <= 15) return 95;
  if (m <= 20) return 110;
  return 120;
}

function costoOperativoMes(m) {
  if (m <= 3)  return 1800000;
  if (m <= 6)  return 1900000;
  if (m <= 12) return 2200000;
  if (m <= 18) return 3000000;
  return 4000000;
}

export function calcularProyeccion(horizonteMeses = 24) {
  const proyeccion = [];
  let tenderosAcumulados = 0;
  let balanceAcumulado = 0;

  for (let m = 1; m <= horizonteMeses; m++) {
    const nuevos = nuevosTenderosDelMes(m);
    const churn  = Math.round(tenderosAcumulados * tasaChurn(m));
    tenderosAcumulados = tenderosAcumulados + nuevos - churn;

    const pxt = pedidosPorTendero(m);
    const pedidosTotales = Math.round(tenderosAcumulados * pxt);

    const revSuscripcion = tenderosAcumulados * SUSCRIPCION_NETA_COP;
    const revTarifas     = pedidosTotales    * TARIFA_NETA_COP;
    const revenueTotal   = revSuscripcion + revTarifas;

    const costoOperativo       = costoOperativoMes(m);
    const comisionConcesion    = Math.round(tenderosAcumulados * SUSCRIPCION_NETA_COP * 0.20);
    const costoTotal           = costoOperativo + comisionConcesion;

    const balance = revenueTotal - costoTotal;
    balanceAcumulado += balance;

    proyeccion.push({
      mes: m,
      nuevos,
      churn,
      tenderosActivos: tenderosAcumulados,
      pedidosPorTendero: pxt,
      pedidosTotales,
      revSuscripcion,
      revTarifas,
      revenueTotal,
      costos: costoTotal,
      balance,
      balanceAcumulado,
    });
  }

  return proyeccion;
}

/** Devuelve el primer mes con balance positivo, o null si no hay. */
export function mesBreakeven(proyeccion) {
  return proyeccion.find(m => m.balance > 0) || null;
}

/** Formatos COP */
export const formatCOP = (v) => {
  const abs = Math.abs(v);
  if (abs >= 1_000_000) return '$' + (v / 1_000_000).toFixed(1) + 'M';
  if (abs >= 1_000)     return '$' + Math.round(v / 1_000) + 'K';
  return '$' + Math.round(v).toLocaleString('es-CO');
};

export const formatFull = (v) =>
  '$' + Math.round(v).toLocaleString('es-CO');
